export class Bookmark {
  jobId: string;
  createdDate: Date;

  constructor(data = {}) {
    this.jobId = data['jobId'];
    this.createdDate = data['createdDate'] ? new Date(data['createdDate']) : undefined;
  }
}
